export const REQUIRED_CHARTER_HEADINGS = [
  'Identity',
  'Rules',
  'Owner',
  'Change Log',
] as const;

/**
 * Validates that all required ## headings are present in the markdown body.
 * Returns list of missing headings.
 */
export function validateHeadings(body: string, requiredHeadings: readonly string[] = REQUIRED_CHARTER_HEADINGS): string[] {
  const headingPattern = /^##\s+(.+)$/gm;
  const found = new Set<string>();
  let match: RegExpExecArray | null;
  while ((match = headingPattern.exec(body)) !== null) {
    found.add(match[1]!.trim());
  }

  return requiredHeadings.filter((h) => !found.has(h));
}
